import { render, staticRenderFns } from "./ShowClassification.vue?vue&type=template&id=14fb6724&scoped=true&"
import script from "./ShowClassification.vue?vue&type=script&lang=js&"
export * from "./ShowClassification.vue?vue&type=script&lang=js&"
import style0 from "./ShowClassification.vue?vue&type=style&index=0&id=14fb6724&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fb6724",
  null
  
)

export default component.exports